import { render, staticRenderFns } from "./JobStats.vue?vue&type=template&id=f79a19fc&scoped=true"
import script from "./JobStats.vue?vue&type=script&lang=js"
export * from "./JobStats.vue?vue&type=script&lang=js"
import style0 from "./JobStats.vue?vue&type=style&index=0&id=f79a19fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79a19fc",
  null
  
)

export default component.exports